import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import {
  FormBuilder,
  FormGroup,
  FormArray,
  Validators,
  FormControl
} from "@angular/forms";
import { DomSanitizer, SafeHtml } from "@angular/platform-browser";
import { ActivatedRoute, Params } from "@angular/router";

import { environment } from "../../../../environments/environment";
import { CrudService } from "../../../crud/crud.service";
import { NotificationsService } from 'angular2-notifications';

import { Mensaje } from "../../../mensaje";

import jsPDF from 'jspdf'; import autoTable from 'jspdf-autotable'; import * as jQuery from 'jquery';
import * as moment from 'moment';

import { materialize } from 'rxjs/operators';

@Component({
  selector: "app-evento-registro",
  templateUrl: "./evento-registro.component.html"
})
export class EventoRegistroComponent implements OnInit{
  dato;

  configuracion = JSON.parse(localStorage.getItem("configuracion"));
  API_PATH = environment.API_PATH;

  cargando = false;
  guardado = false;
  evento;
  evento_registro;
  evento_nombre;
  evento_registro_nombre;
  evento_registro_codigo_confirmacion;
  evento_registro_codigo_prerregistro;

  abonado = 0;
  aPagar = 0;

  mensajeResponse: Mensaje = new Mensaje(true);
  //mostrar notificaciones
  public options = {
    position: ["middle", "center"],
    timeOut: 3000,
    lastOnBottom: true
  };

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private crudService: CrudService,
    private notificacion: NotificationsService
  ) { }
  ngOnInit() {
    document.getElementById("catalogos").click();
  }
  seleccionarEvento(event) {
    this.dato = {};
    this.evento = event.value;
  }
  seleccionarEventoRegistro(event, registrados, eventos) {
    this.dato = {}; this.abonado = 0; this.aPagar = 0;
    this.evento_registro = event.value;
    eventos.forEach(element => {
      if (this.evento==element.id) {
        this.evento_nombre = element.nombre;
        element.eventos_costos.forEach(ec => {
          this.aPagar = +ec.importe;
        });
        return false;
      }
    });
    registrados.forEach(element => {
      if (this.evento_registro==element.id) {
        this.dato = element;
      }
    });

    if (this.dato.eventos_registros_cajas.length>0) {
      this.dato.eventos_registros_cajas.forEach(caja => {
        this.abonado= +caja.cajas.monto;
      });
    }

    this.dato.validado = false;
    this.dato.aPagar = this.aPagar;
    this.dato.abonado = this.abonado;
    if (this.abonado>=this.aPagar) {
      this.dato.validado = true;
    }
  }


  cargarDatos() {
      this.cargando = true;
      this.guardado = false;
      let json = this.dato;

      this.crudService.editar(this.dato.id, json, "evento-registro").subscribe(
        resultado => {
          this.dato = {};
          this.guardado = true;
          this.cargando = false;
          if (resultado.status == 200 || resultado.status == 201 ){
            this.mensajeResponse.texto = 'Se confirmó el registro!"';
            this.mensajeResponse.mostrar = true;
            this.mensajeResponse.clase = "success";
            this.mensaje(3);



            setTimeout(() => {
              this.dato = resultado.data;
            }, 1000);
          }
          else {
            this.mensajeResponse.texto = 'No se guardado los cambios."';
            this.mensajeResponse.mostrar = true;
            this.mensajeResponse.clase = "warning";
            this.mensaje(3);
          }
        },
        error => {
          this.cargando = false;
          this.guardado = false;
          this.mensajeResponse.texto = "No especificado.";
          this.mensajeResponse.mostrar = true;
          this.mensajeResponse.clase = "error";
          this.mensaje(3);

          try {
            let e = error.json();
            if (error.status == 401) {
              this.mensajeResponse.texto =
                "No tiene permiso para hacer esta operación.";
            }
            //  Problema de validación
            if (error.status == 409) {
              this.mensajeResponse.texto =
                "Por favor verfique los campos marcados en rojo.";
              this.mensajeResponse.clase = "warning";
              this.mensaje(8);
              for (let input in e.error) {
                //  Iteramos todos los errores
                for (let i in e.error[input]) {
                  this.mensajeResponse.titulo = input;
                  this.mensajeResponse.texto = e.error[input][i];
                  this.mensajeResponse.clase = "error";
                  this.mensaje(3);
                }
              }
            }
          } catch (e) {
            if (error.status == 500) {
              this.mensajeResponse.texto = "500 (Error interno del servidor)";
            } else {
              this.mensajeResponse.texto =
                "No se puede interpretar el error. Por favor contacte con soporte técnico si esto vuelve a ocurrir. 2";
            }
          }
        }
      );



  }

  mensaje(
    cuentaAtras: number = 6,
    posicion: any[] = ["middle", "center"]
  ): void {
    let objeto = {
      showProgressBar: true,
      pauseOnHover: true,
      clickToClose: true,
      maxLength: this.mensajeResponse.texto.length
    };

    this.options = {
      position: posicion,
      timeOut: cuentaAtras * 1000,
      lastOnBottom: true
    };

    if (this.mensajeResponse.clase == "alert")
      this.notificacion.alert(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );

    if (this.mensajeResponse.clase == "success")
      this.notificacion.success(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );

    if (this.mensajeResponse.clase == "info")
      this.notificacion.info(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );

    if (
      this.mensajeResponse.clase == "warning" ||
      this.mensajeResponse.clase == "warn"
    )
      this.notificacion.warn(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );

    if (
      this.mensajeResponse.clase == "error" ||
      this.mensajeResponse.clase == "danger"
    )
      this.notificacion.error(
        this.mensajeResponse.titulo,
        this.mensajeResponse.texto,
        objeto
      );
  }


  imprimirConfirmado() {
    let color = "#FFFFFF"; //$(".hero.is-primary").css("background-color");
    // let tamanio = ss.split(":");
    
    let doc = new jsPDF("l", "mm", [216,279]);

    let width = doc.internal.pageSize.getWidth();
    let height = doc.internal.pageSize.getHeight();

    this.dato.eventos_constancias.forEach((par, key) => {
      doc.setFontSize(par.font_size);
      doc.setFont(par.font_family);

      this.dato.confirmados.forEach((per, k) => {
        doc.addImage(par.fondo, "PNG", 0, 0, width, height, "left", "FAST");
        doc.text(per.apellido_paterno + " " + per.apellido_materno + " " + per.nombre, par.mm_x, par.mm_y, {align:'center'});
        // if (k > 0 && k < (this.dato.confirmados.length - 1))
        // doc.addPage();
      });

      // if (key < (this.dato.eventos_constancias.length - 1))
      //   doc.addPage();
    });

    // doc.autoPrint();
    //const string = (doc as any).output('datauristring', 'evento_registro_confirmado.pdf');
    window.open((doc as any).output('bloburl'), '_blank');
    /*const iframe = "<iframe border='0' style='border:0px' width='100%' height='100%' src='" + string + "'></iframe>"

    const x = window.open();
    x.document.open();
    x.document.write(iframe);
    x.document.close();*/
  }

  // imprimirConfirmado() {
  //   let color = "#FFFFFF"; //$(".hero.is-primary").css("background-color");

  //   let doc = new jsPDF("p", "mm", "letter");

  //   let logo = this.logo_sucursal != '' ? this.logo_sucursal : this.logo_empresa;
  //   if (logo != '' && logo != undefined && logo != null)
  //     doc.addImage(logo, "PNG", 7, 5, 30, 20, "left", "FAST");

  //   //Nombre empresa
  //   doc.setFontSize(16);
  //   doc.setFont("helvetica", "", "bold");
  //   doc.text(110, 12, this.configuracion.empresa.nombre, 'center');

  //   doc.setFontSize(10);
  //   doc.setFont("helvetica", "", "normal");
  //   doc.text(110, 18, 'Campus: ' + this.configuracion.sucursal.nombre, 'center');

  //   doc.setFontSize(10);
  //   doc.setFont("helvetica", "", "bold");
  //   doc.text(110, 28, "LISTA DE ASISTENCIA", "center");

  //   doc.setFontSize(8);
  //   doc.setFont("helvetica", "", "bold");

  //   doc.text(15, 40, "EVENTO: " + this.dato.nombre, "left");
  //   doc.text(15, 45, "FECHA: del " + this.dato.fecha_inicio + " al " + this.dato.fecha_termino, "left");


  //   let columns = [
  //     { title: "N", dataKey: "id" },
  //     { title: "Nombre", dataKey: "nombre" },
  //     { title: "Correo", dataKey: "correo" },
  //     { title: "Telefono", dataKey: "telefono" },
  //     { title: "Codigo", dataKey: "codigo" },
  //     { title: "Asistencia", dataKey: "asistencia" }
  //   ];

  //   let rows = []; let linea = 1;
  //   this.dato.confirmados.forEach(par => {
  //     rows.push({
  //       id: linea,
  //       nombre: par.apellido_paterno + " " + par.apellido_materno + " " + par.nombre,
  //       correo: par.email,
  //       telefono: par.telefono,
  //       codigo: par.codigo_confirmacion,
  //       asistencia: ''
  //     });
  //   });

  //   (doc as any).autoTable({
  //          columns:columns, 
  //          body: rows,
  //     didParseCell : function (cell) {
  //            let data= cell;
  //            cell = cell.cell;
  //       cell.styles.fillColor = "#ffffff";
  //     },
  //     startY: 50,
  //     styles: {
  //       fontSize: 8,
  //       halign: "center",
  //       fillColor: color
  //     },
  //     theme: "grid",
  //     columnStyles: {
  //       id: { cellWidth: 20 },
  //       alumno: {
  //         cellWidth: 40,
  //         halign: "left"
  //       },
  //       asistencia: { cellWidth: 20 }
  //     }
  //   });

  //   // doc.autoPrint();
  //   const string = (doc as any).output('datauristring', 'evento_confirmados.pdf');

  //   /*const iframe = "<iframe border='0' style='border:0px' width='100%' height='100%' src='" + string + "'></iframe>"

  //   const x = window.open();
  //   x.document.open();
  //   x.document.write(iframe);
  //   x.document.close();*/

  // }

  // imprimirInscritos() {
  //   let color = "#FFFFFF"; //$(".hero.is-primary").css("background-color");

  //   let doc = new jsPDF("p", "mm", "letter");

  //   let logo = this.logo_sucursal != '' ? this.logo_sucursal : this.logo_empresa;
  //   if (logo != '' && logo != undefined && logo != null)
  //     doc.addImage(logo, "PNG", 7, 5, 30, 20, "left", "FAST");

  //   //Nombre empresa
  //   doc.setFontSize(16);
  //   doc.setFont("helvetica", "", "bold");
  //   doc.text(110, 12, this.configuracion.empresa.nombre, 'center');

  //   doc.setFontSize(10);
  //   doc.setFont("helvetica", "", "normal");
  //   doc.text(110, 18, 'Campus: ' + this.configuracion.sucursal.nombre, 'center');

  //   doc.setFontSize(10);
  //   doc.setFont("helvetica", "", "bold");
  //   doc.text(110, 28, "LISTA DE INSCRITOS", "center");

  //   doc.setFontSize(8);
  //   doc.setFont("helvetica", "", "bold");

  //   doc.text(15, 40, "EVENTO: " + this.dato.nombre , "left");
  //   doc.text(15, 45, "FECHA: del " + this.dato.fecha_inicio + " al " + this.dato.fecha_termino, "left");


  //   let columns = [
  //     { title: "N", dataKey: "id" },
  //     { title: "Nombre", dataKey: "nombre" },
  //     { title: "Correo", dataKey: "correo" },
  //     { title: "Telefono", dataKey: "telefono" },
  //     { title: "Codigo", dataKey: "codigo" },
  //     { title: "Confirmacion", dataKey: "confirmar" }
  //   ];

  //   let rows = []; let linea = 1;
  //   this.dato.registrados.forEach(par => {
  //     rows.push({
  //       id: linea,
  //       nombre: par.apellido_paterno + " " + par.apellido_materno + " " + par.nombre,
  //       correo: par.email,
  //       telefono: par.telefono,
  //       codigo: par.codigo_prerregistro,
  //       confirmar: par.codigo_confirmacion ? par.codigo_confirmacion : '--'
  //     });
  //   });

  //   (doc as any).autoTable({
  //          columns:columns, 
  //          body: rows,
  //     didParseCell : function (cell) {
  //            let data= cell;
  //            cell = cell.cell;
  //       cell.styles.fillColor = "#ffffff";
  //     },
  //     startY: 50,
  //     styles: {
  //       fontSize: 8,
  //       halign: "center",
  //       fillColor: color
  //     },
  //     theme: "grid",
  //     columnStyles: {
  //       id: { cellWidth: 20 },
  //       alumno: {
  //         cellWidth: 40,
  //         halign: "left"
  //       }
  //     }
  //   });

  //   // doc.autoPrint();
  //   const string = (doc as any).output('datauristring', 'evento_confirmados.pdf');

  //   /*const iframe = "<iframe border='0' style='border:0px' width='100%' height='100%' src='" + string + "'></iframe>"

  //   const x = window.open();
  //   x.document.open();
  //   x.document.write(iframe);
  //   x.document.close();*/

  // }

  logo_sucursal;
  logo_empresa;
  asignarLogos(logos) {
    if (logos) {
      this.logo_sucursal = logos.sucursal;
      this.logo_empresa = logos.empresa;
    }
  }
}
